module.exports = __webpack_public_path__ + "static/img/case_banner_03_h5.c79d0d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_03_h5.png
// module id = XLGk
// module chunks = 34